var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.value)?_c('base-link',_vm._g({attrs:{"href":_vm.filtered_value,"title":_vm.title}},_vm.$listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }